import { Icon } from '@orionprotocol/ui';
import { Trans } from '@lingui/react';
import cn from 'classnames';

import styles from './Footer.module.scss';

export function Footer(): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={cn(styles.column, styles.columnLogo)}>
        <Icon icon="logo" className={styles.logoDesktop} />
        <Trans id="lumia-all-rights" message="{year} Lumia, All Rights Reserved." values={{ year: (new Date()).getFullYear() }} />
      </div>

      <div className={styles.column}>
        <div className={styles.title}>
          <Trans id="product" message="Product" />
        </div>
        <div className={styles.text}>
          <a
            href="https://lumia.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans id="product" message="Product" />
          </a>
        </div>
      </div>

      <div className={styles.column}>
        <div className={styles.title}>
          <Trans id="developers" message="Developers" />
        </div>
        <div className={styles.text}>
          <a
            href="https://docs.lumia.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans id="docs" message="Docs" />
          </a>
        </div>
      </div>

      <div className={styles.column}>
        <div className={styles.title}>
          <Trans id="company" message="Company" />
        </div>
        <div className={styles.text}>
          <a
            href="mailto:contact@lumia.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans id="contact" message="Contact" />
          </a>
        </div>
      </div>

      <div className={styles.column}>
        <div className={styles.title}>
          <Trans id="social-media" message="Social Media" />
        </div>
        <div className={styles.socialRow}>
          <a
            href="https://x.com/BuildOnLumi"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="x" />
          </a>
          <a
            href="https://t.me/lumia_community"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="telegram" />
          </a>
        </div>
      </div>
    </div>
  )
}